import errors from "./constants";

export default function required(value: unknown) {
  return !value ||
    (typeof value === "string" && !value.trim()) ||
    (Array.isArray(value) && !value.length)
    ? errors.required
    : undefined;
}
